import Vue from 'vue'
import Router from 'vue-router'
import Login from '../views/login'
import loginSingle from '../views/Public/loginSingle'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}
/*const Home = () => import('../views/Dashboard/admin/index')*/
const Home = () => import('../views/Welcome')
const Thanks = () => import('../views/Thanks')
//const MyHome = () => import('../views/Task/Mobile/MyHome')
//const AddTask = () => import('../views/Task/Mobile/AddTask')
//const MyWaitDo = () => import('../views/Task/Mobile/MyWaitDo')
//const MyWaitRead = () => import('../views/Task/Mobile/MyWaitRead')
//const MyWaitApproval = () => import('../views/Task/Mobile/MyWaitApproval')
//const MyComplated = () => import('../views/Task/Mobile/MyComplated')
//const EditTaskProgress = () => import('../views/Task/Mobile/EditTaskProgress')
const NoPage = () => import('../views/404')
const refuse = () => import('../views/refuse')
const addUser = () => import('../views/addUser')
const printUser = () => import('../views/printUser')
const emptyPage = () => import('../views/emptyPage')
const Layout = () => import('../views/Layout/Layout')
const userTemplate = () => import('../views/userTemplate')

// 共享中心
const teaminfo = () => import('../views/SharingCenter/teaminfo')
const postInfo = () => import('../views/SharingCenter/postInfo')
const dptinfo = () => import('../views/SharingCenter/dptinfo')
const Recruitment = () => import('../views/SharingCenter/Recruitment')
const SalaInterview = () => import('../views/SharingCenter/SalaInterview')
const Positive = () => import('../views/SharingCenter/Positive')
const TransferCenter = () => import('../views/SharingCenter/TransferCenter')
const RewardsCenter = () => import('../views/SharingCenter/RewardsCenter')
const _import = require('@/router/_import_' + process.env.NODE_ENV)//获取组件的方法

import IdentityServerRefreshToken from "../views/IdentityServerRefreshToken";
Vue.use(Router)

const createRouter = () => new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
      {
          path: '/login', component: Login, name: 'login',
          meta: {
              title: '登录',
              requireAuth: false,
              NoTabPage: true,
              NoNeedHome: true // 添加该字段，表示不需要home模板
          },
          hidden: true
      },
    {
      path: '/404', component: NoPage, name: 'NoPage',
      meta: {
        title: 'NoPage',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: true // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
    {
      path: '/emptyPage', component: emptyPage, name: 'emptyPage',
      meta: {
        title: 'emptyPage',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: true // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
    {
      path: '/userTemplate', component: userTemplate, name: 'userTemplate',
      meta: {
        title: 'userTemplate',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: false // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
   
    {
      path: '/printUser', component: printUser, name: 'printUser',
      meta: {
        title: 'printUser',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: true // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
    {
      path: '/refuse', component: refuse, name: 'refuse',
      meta: {
        title: 'refuse',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: true // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
    {
      path: '/addUser', component: addUser, name: 'addUser',
      meta: {
        title: 'addUser',
        requireAuth: false,
        NoTabPage: true,
        NoNeedHome: true // 添加该字段，表示不需要home模板
      },
      hidden: true
    },
    {
      path: '/Thanks', component: Thanks, name: 'Thanks',
      meta: {
        title: 'Thanks',
        requireAuth: false
      },
      hidden: true
    },
    //{
    //  path: '/MyHome', component: MyHome, name: 'MyHome',
    //  meta: {
    //    title: 'MyHome',
    //    NoTabPage: true,
    //    NoNeedHome: true,
    //    requireAuth: false
    //  },
    //  hidden: true
    //},
    // 共享中心
    {
      path: '/SharingCenter/teaminfo', component: teaminfo, name: 'teaminfo',
      meta: {
        title: 'teaminfo',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/dptinfo', component: dptinfo, name: 'dptinfo',
      meta: {
        title: 'dptinfo',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/Recruitment', component: Recruitment, name: 'Recruitment',
      meta: {
        title: 'Recruitment',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/SalaInterview', component: SalaInterview, name: 'SalaInterview',
      meta: {
        title: 'SalaInterview',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/postInfo', component: postInfo, name: 'postInfo',
      meta: {
        title: 'postInfo',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/Positive', component: Positive, name: 'Positive',
      meta: {
        title: 'Positive',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/TransferCenter', component: TransferCenter, name: 'TransferCenter',
      meta: {
        title: 'TransferCenter',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    {
      path: '/SharingCenter/RewardsCenter', component: RewardsCenter, name: 'RewardsCenter',
      meta: {
        title: 'RewardsCenter',
        NoTabPage: true,
        NoNeedHome: false,
        requireAuth: false
      },
      hidden: true
    },
    // {
    //   path: '/Task/Mobile/MyHome', component: MyHome, name: 'MyHome',
    //   meta: {
    //     title: 'MyHome',
    //     NoTabPage: true,
    //     NoNeedHome: true,
    //     requireAuth: true
    //   },
    //   hidden: true
    // },
    // {
    //     path: '/Task/Mobile/MyHome',component: MyHome,name: 'MyHome',
    //     meta: {
    //         title: '移动端首页',
    //         NoTabPage: true,
    //         NoNeedHome: true,
    //         requireAuth: true
    //     },
    //     hidden: true
    // },
    //{
    //    path: '/AddTask',component: AddTask,name: 'AddTask',
    //    meta: {
    //        title: '添加日常任务',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
    //{
    //    path: '/MyWaitDo',component: MyWaitDo,name: 'MyWaitDo',
    //    meta: {
    //        title: '待办任务列表',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
    //{
    //    path: '/MyWaitRead',component: MyWaitRead,name: 'MyWaitRead',
    //    meta: {
    //        title: '待阅任务列表',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
    //{
    //    path: '/MyWaitApproval',component: MyWaitApproval,name: 'MyWaitApproval',
    //    meta: {
    //        title: '待审核任务列表',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
    //{
    //    path: '/MyComplated',component: MyComplated,name: 'MyComplated',
    //    meta: {
    //        title: '已完成任务列表',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
    //{
    //    path: '/EditTaskProgress',component: EditTaskProgress,name: 'EditTaskProgress',
    //    meta: {
    //        title: '维护任务进度',
    //        NoTabPage: true,
    //        NoNeedHome: true,
    //        requireAuth: false
    //    },
    //    hidden: true
    //},
  
    {
      path: '/',
      type: 'home',
      component: Home,
      name: '首页',
      // hidden: true,
      meta: {
        title: '首页',
        requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    
    {
      path: "/IdentityServerRefreshToken",
      name: "IdentityServerRefreshToken",
      component: IdentityServerRefreshToken,
      meta: {
        title: '刷新',
        NoTabPage: true,
      },
      hidden: true
    },
    {
      path: '*',
      hidden: true,
      redirect: { path: '/404' }
      },
      {
          path: '/loginSingle', component: loginSingle, name: 'loginSingle',
          meta: {
              title: 'loginSingle',
              requireAuth: false,
              NoTabPage: true,
              NoNeedHome: true // 添加该字段，表示不需要home模板
          },
          hidden: true
      },
  ]
})

const router = createRouter()

export function filterAsyncRouter (asyncRouterMap) {
  // console.log(asyncRouterMap)
if(asyncRouterMap){
  //注意这里的 asyncRouterMap 是一个数组
  const accessedRouters = asyncRouterMap.filter(route => {
    // console.log(route)
     route.meta = {
      title:  route.name,
      requireAuth: true // 添加该字段，表示进入这个路由是需要登录的
     }
    if (route.path && !route.IsButton) {
      if (route.path === '/' || route.path === '-') {//Layout组件特殊处理
        route.component = Layout
      }
      else if (route.type == 1) {
        route.path = "/userTemplate?reportUrl="+route.path+"&reportType=0&t="+Date.now();
        route.component = () => import('@/views//userTemplate.vue');
      } else {
        try {
          route.component = _import(route.path.replace('/:id', ''))
        } catch (e) {
          try {
           
            route.component = () => import('@/views' + route.path.replace('/:id', '') + '.vue');
          

          } catch (error) {
            console.info('%c 当前路由 ' + route.path.replace('/:id', '') + '.vue 不存在，因此如法导入组件，请检查接口数据和组件是否匹配，并重新登录，清空缓存!', "color:red")
          }
        }
      }
    }
    if (route.children && route.children.length && !route.IsButton) {
      route.children = filterAsyncRouter(route.children)
    }
    return true
  })

  return accessedRouters
}
}

export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // the relevant part
}


router.$addRoutes = (params) => {
//console.log(params)
if(params){
  var f = item => {

    if (item['children']) {
      item['children'] = item['children'].filter(f);
      return true;
    } else if (item['IsButton']) {
      return item['IsButton'] === false;
    } else {
      return true;
    }

  }

  var params = params.filter(f);
// console.log(params)
  router.addRoutes(params)
}
}

export default router;

